// extracted by mini-css-extract-plugin
export default {"dots":"Aq_5Zi","dot":"CQWApA","bounce":"cxui24","dot1":"I5TvG9 CQWApA","dot2":"eVPYcF CQWApA","dot3":"rWaGgP CQWApA"};